import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';

import Draggable from 'react-draggable';

import { useSelector, useDispatch } from 'react-redux';
import {
  startMeasure,
  stopMeasure,
  cleanMeasure,
} from '../../redux/actions/mesure';

import { innerColor, themeColor } from '../../constants/themes';

const MeasureUtil = (props) => {
  const map = props.basemap;
  const visibleMeasure = props.visible;
  const setVisibleMeasure = props.visibleFunc;

  const dispatch = useDispatch();

  return (
    <Draggable>
      <Card
        sx={{
          position: 'absolute',
          marginRight: '4em',
          zIndex: 99999,
          display: visibleMeasure,
        }}
      >
        <CardHeader
          sx={{
            color: innerColor,
            backgroundColor: themeColor,
          }}
          title="Ölçüm Araçları"
          titleTypographyProps={{ variant: 'h6' }}
          action={
            <IconButton
              sx={{ backgroundColor: 'grey' }}
              onClick={() => setVisibleMeasure('none')}
            >
              <CloseIcon />
            </IconButton>
          }
        />
        <CardContent
          style={{ display: 'flex', flexDirection: 'column', padding: '1em' }}
        >
          <ButtonGroup
            variant="outlined"
            aria-label="outlined primary button group"
          >
            <Tooltip title="Uzunluk Ölç">
              <Button
                onClick={() => {
                  dispatch(startMeasure(map, 'LineString'));
                }}
              >
                <i className="fg-measure-line fg-2x"></i>
              </Button>
            </Tooltip>
            <Tooltip title="Alan Ölç">
              <Button
                onClick={() => {
                  dispatch(startMeasure(map, 'Polygon'));
                }}
              >
                <i className="fg-measure-area fg-2x"></i>
              </Button>
            </Tooltip>
          </ButtonGroup>
        </CardContent>
        <CardActions>
          <ButtonGroup
            size="small"
            variant="contained"
            orientation="vertical"
            fullWidth
          >
            <Button
              onClick={() => {
                dispatch(stopMeasure(map));
              }}
            >
              Ölçümü Bitir
            </Button>
            <Button
              onClick={() => {
                dispatch(cleanMeasure(map));
              }}
            >
              Ölçümü Temizle
            </Button>
          </ButtonGroup>
        </CardActions>
      </Card>
    </Draggable>
  );
};

export default MeasureUtil;
